import React from 'react';
import {
    Container, Button, Loader, Image, Icon, Dimmer, TextArea, Form, Header, Dropdown, Divider
} from "semantic-ui-react";
import "./CustomForm.css";
import { exceptionMessage, toastStyle, exp2, importIframeURL } from '../../Config';
import { getLeadByPhone, createOrUpdateLead, postActivityOnLead, preSubmission } from '../../services';

import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import CustomMessage from '../Modal/Popup';

class CustomForm extends React.PureComponent {

    constructor(props) {
        super(props);
        this.initialState = {
            ButtonLoader: false,
            firstName: '',
            lastName: '',
            parentName: '',
            email: '',
            phone: '',
            city: '',
            pin: '',
            owner: '',
            ownerId: '',
            className: '',
            classDropdown: [],
            buttonDisabled: true,
            btnLoader: false,
            result: [],
            loader: false,
            visible: false,
            open: false,
            message: '',
            searchDisabled: true,
            customLoaderMessage: '',
            readOnly: false,
            validated: false,
            orgId: '',
            iframeVisible: true
        };
        this.state = this.initialState;
    }



    onChange = (e) => {

        this.setState({
            ...this.state,
            [e.target.name]: e.target.value
        });
    };


    handleChangedValue = (event, data) => {
        let newState = { ...this.state }
        newState = ({
            ...newState, [data.name]: data.value
        });
        this.setState(newState);
    };

    fetchLead = (phone, retry = 0) => {
        let payload = { 'phone': `+91-${phone}`, 'orgcode': this.props.orgCode };

        this.setState({ loader: true, customLoaderMessage: 'Fetching lead details...' });
        getLeadByPhone(payload).then(res => {

            let response = res.data.message;
            if (response.length > 0) {
                let { FirstName, LastName, mx_Parent_Name, EmailAddress, Phone, mx_po_pincode, OwnerId, mx_City, mx_Class, OwnerIdEmailAddress } = response[0];
                console.log('response', response)
                this.setState({
                    result: response, firstName: FirstName,
                    lastName: LastName ? LastName : '',
                    parentName: mx_Parent_Name ? mx_Parent_Name : '',
                    email: EmailAddress ? EmailAddress : '',
                    className: mx_Class,
                    owner: OwnerIdEmailAddress,
                    ownerId: OwnerId,
                    pin: mx_po_pincode ? mx_po_pincode : '',
                    city: mx_City ? mx_City : '',
                    phone: Phone ? Phone.substr(-10) : Phone,
                    loader: false,
                    visible: true,
                    searchDisabled: true,
                    customLoaderMessage: '',
                    readOnly: true
                })
            }
            else {
                let result = {
                    email: '', result: [], firstName: '', lastName: '', parentName: '', className: '', owner: this.props.ownerEmail, ownerId: this.props.ownerId, customLoaderMessage: '', visible: true, loader: false, message: 'Lead is not found with given search, please add lead manually.', open: true, searchDisabled: true
                }
                this.setState({ ...result });
            }

        }).catch(error => {

            if (error && error.ExceptionType == "MAXAPIRateLimitExceedException") {
                error = exceptionMessage;
                retry += 1;
                if (retry < 3) {
                    //retry after 1 min 
                    setTimeout(this.fetchLead(phone, retry), 5000);
                }
                else {
                    error = exp2;
                }
            }
            else {
                error = `Error while fetching lead Details  -${error}`
            }
            this.setState({ loader: false, message: error, open: true });
        });

    }

    handleSubmit = event => {
        event.preventDefault();
        this.setState({ ButtonLoader: true, loader: true, customLoaderMessage: 'Saving lead details...' });

        let newState = { ...this.state };
        let { firstName, lastName, parentName, email, phone, city, pin, className } = newState
        let payload = [
            {
                "Attribute": "FirstName",
                "Value": firstName
            },
            {
                "Attribute": "LastName",
                "Value": lastName
            },
            {
                "Attribute": "mx_Parent_Name",
                "Value": parentName
            },
            {
                "Attribute": "EmailAddress",
                "Value": email
            },
            {
                "Attribute": "Phone",
                "Value": `+91-${phone}`
            },
            {
                "Attribute": "mx_City",
                "Value": city
            },
            {
                "Attribute": "mx_po_pincode",
                "Value": pin
            },
            {
                "Attribute": "mx_Class",
                "Value": className
            },
            {
                "Attribute": this.state.orgId == '24692' ? "mx_called_by" : this.state.orgId == '46867' ? 'mx_registration_fee' : 'mx_mall_name',
                "Value": this.props.ownerId
            },
            {
                "Attribute": this.state.orgId == '24692' ? "mx_Father_Profession" : this.state.orgId == '46867' ? 'mx_BTC_Father_Name' : 'mx_FB_Team',
                "Value": moment(new Date()).format('YYYY-MM-DD hh:mm:ss')
            },
            {
                "Attribute": this.state.orgId == '24692' ? "mx_Mother_Profession" : this.state.orgId == '46867' ? 'mx_CDA_First_Name' : 'mx_Street2',
                "Value": this.props.ownerEmail
            }
        ];

        if (this.state.result.length == 0) {
            payload.push({
                "Attribute": "OwnerId",
                "Value": this.state.ownerId
            })
        }

        //counter logic
        if (this.state.result.length > 0) {
            let counter = 0;
            if (this.state.orgId == '24692') {
                counter = this.state.result[0]['mx_Gifted_amount'] ? this.state.result[0]['mx_Gifted_amount'] : 0
            }
            else if (this.state.orgId == '46867') {
                counter = this.state.result[0]['mx_DSSL_Result_Key'] ? this.state.result[0]['mx_DSSL_Result_Key'] : 0
            }
            else {
                counter = this.state.result[0]['mx_D2019_Incorrect'] ? this.state.result[0]['mx_D2019_Incorrect'] : 0
            }

            payload.push({
                "Attribute": this.state.orgId == '24692' ? "mx_Gifted_amount" : this.state.orgId == '46867' ? 'mx_DSSL_Result_Key' : 'mx_D2019_Incorrect',
                "Value": Number(counter) + 1
            })

        }

        console.log('payload', payload)
        // return;
        //return;
        // console.log('props', this.props)

        //checking verfication is done or not
        preSubmission({ 'phone': phone, 'orgcode': this.state.orgId }).then(res => {
            //console.log('res', res)
            if (res.data.message.IsSuccess == true) {
                this.formSubmission(payload)
            }
            else {
                this.setState({ message: `Otp is not verified`, open: true, ButtonLoader: false, loader: false, customLoaderMessage: '' })
            }

        }).catch(error => {
            this.setState({ message: `Error while pfetching otp verification details -${error}`, open: true, ButtonLoader: false, loader: false, customLoaderMessage: '' })
        });


    }

    formSubmission = (payload, retry = 0) => {
        //console.log('payload', payload)

        createOrUpdateLead({ 'payload': payload, 'orgcode': this.state.orgId }).then(res => {
            let response = res.data.message;
            let jsonData = {
                "RelatedProspectId": response.Message.Id,
                "ActivityEvent": this.props.orgCode == 24692 ? 1422 : this.props.orgCode == 46867 ? 1252 : 1120,
                "Fields": [
                    {
                        "SchemaName": "Owner",
                        "Value": this.props.ownerId
                    }
                    //,
                    // {
                    //     "SchemaName": "mx_Custom_1",
                    //     "Value": moment(new Date()).format('YYYY-MM-DD hh:mm:ss')
                    // },
                    // {
                    //     "SchemaName": "mx_Custom_2",
                    //     "Value": this.props.ownerEmail
                    // }
                ]
            };
            if (response.Status == "Success") {
                postActivityOnLead({ 'jsonData': jsonData, 'orgcode': this.state.orgId, 'phone': this.state.phone }).then(res => {
                    if (res.data.message.Status == "Success") {
                        let msg = this.state.result.length > 0 ? 'updated' : 'created'
                        this.setState({ ...this.initialState, message: `Lead has been ${msg} and activity posted successfully`, open: true });
                    }
                    else {
                        this.setState({ message: `Error while Posting Bulk Activities`, open: true, ButtonLoader: false, loader: false, customLoaderMessage: '' })
                    }


                }).catch(error => {
                    this.setState({ message: `Error while posting activity -${error}`, open: true, ButtonLoader: false, loader: false, customLoaderMessage: '' })
                });
            }
            else {
                this.setState({
                    loader: false, ButtonLoader: false, message: `Error in Saving Lead deatils. ${response.ExceptionMessage}
                `, open: true, customLoaderMessage: ''
                });
            }

        }).catch(error => {

            if (error && error.ExceptionType == "MAXAPIRateLimitExceedException") {
                error = exceptionMessage;
                retry += 1;
                if (retry < 3) {
                    //retry after 1 min 
                    setTimeout(this.formSubmission(payload, retry), 5000);
                }
                else {
                    error = exp2;
                }
            }
            else {
                error = `Error while fetching lead Details  -${error}`
            }
            this.setState({ loader: false, ButtonLoader: false, open: true, message: error, customLoaderMessage: '' });
        });

    }

    //closing modal
    setClose = () => {
        this.setState({ open: false, message: '' })
    }

    check = (e) => {
        let { phone } = { ...this.state }
        this.setState({ searchDisabled: true })

        if (phone) {
            this.fetchLead(phone)
        }

    }

    componentWillUpdate(nextProps, nextState) {
        //console.log('nextProps', nextProps);
        nextState.buttonDisabled = !(nextState.email && nextState.phone && nextState.firstName && nextState.parentName && nextState.owner && nextState.pin && nextState.city && nextState.className);
        nextState.searchDisabled = !(nextState.phone.length >= 10)
        nextState.iframeVisible = !(nextState.email && nextState.phone && nextState.firstName && nextState.parentName && nextState.owner && nextState.pin && nextState.city && nextState.className);

        if (nextProps.orgCode != this.state.orgId) {
            //console.log('called')

            if (nextProps.orgCode == "46867") {
                nextState.classDropdown = [
                    { key: "Class 11", value: "11", text: "Class 11" },
                    { key: "Class 12", value: "12", text: "Class 12" }
                ]
            }
            else if (nextProps.orgCode == "24692") {
                nextState.classDropdown = [
                    { key: "Class 4", value: "4", text: "Class 4" },
                    { key: "Class 5", value: "5", text: "Class 5" },
                    { key: "Class 6", value: "6", text: "Class 6" },
                    { key: "Class 7", value: "7", text: "Class 7" },
                    { key: "Class 8", value: "8", text: "Class 8" },
                    { key: "Class 9", value: "9", text: "Class 9" },
                    { key: "Class 10", value: "10", text: "Class 10" }
                ]
            }
            else if (nextProps.orgCode == "50476") {
                nextState.classDropdown = [
                    { key: "UKG", value: "UKG", text: "UKG" },
                    { key: "LKG", value: "LKG", text: "LKG" },
                    { key: "Class 1", value: "1", text: "Class 1" },
                    { key: "Class 2", value: "2", text: "Class 2" },
                    { key: "Class 3", value: "3", text: "Class 3" }
                ]
            }
            else {
                nextState.classDropdown = []
            }
            nextState.orgId = nextProps.orgCode
            nextState.ownerId = nextProps.ownerId
        }

    }

    render() {
        console.log('state', this.state)
        return (
            <Container className="custom-container">

                <Header as='h3' icon dividing color="blue" className="custom-header">
                    <Header.Content>Inside sales referral process Form</Header.Content>
                </Header>

                <Form class="ui form" size="small" onSubmit={this.handleSubmit}>

                    <Dimmer active={this.state.loader} inverted>
                        <Loader size='medium'>{this.state.customLoaderMessage}</Loader>
                    </Dimmer>

                    <Form.Group widths='equal'>

                        <Form.Field
                            label="Org Id"
                            placeholder="Org Id"
                            control='input'
                            type="text"
                            value={this.props.orgCode}
                            name='orgId'
                            disabled

                        />
                        <Form.Field
                            label="Product"
                            placeholder="Product"
                            control='input'
                            type="text"
                            value={this.props.orgCode == 24692 ? 'K9' : this.props.orgCode == 46867 ? 'JEE' : 'K3'}
                            name='product'
                            disabled

                        />
                    </Form.Group>


                    <Form.Group widths='equal'>

                        <Form.Field
                            label='Enter Phone Number'
                            fluid
                            placeholder='Phone Number'
                            control='input'
                            type="number"
                            value={this.state.phone}
                            onChange={e => this.setState({ ...this.state, searchDisabled: false, phone: e.target.value, firstName: '', lastName: '', parentName: '', class: '', owner: '', result: [] })}
                            name='phone'

                        /> <Form.Field></Form.Field>

                    </Form.Group>
                    <Form.Group>
                        <Form.Field>
                            <Button type="button" color='primary' disabled={this.state.searchDisabled} onClick={(e) => this.check(e)} >
                                <Icon name='search' /> Search
                            </Button>
                        </Form.Field>

                    </Form.Group>
                    <Header as='h3' icon dividing color="blue" className="custom-header">
                    </Header>

                    {this.state.visible == true ? <>

                        <Form.Group widths='equal'>
                            <Form.Field required
                                label='First Name'
                                placeholder='First Name'
                                control='input'
                                type="text"
                                value={this.state.firstName}
                                onChange={(e) => { this.onChange(e) }}
                                name='firstName'

                            />

                            <Form.Field
                                label='Last Name'
                                placeholder='last Name'
                                control='input'
                                type="text"
                                value={this.state.lastName}
                                onChange={(e) => { this.onChange(e) }}
                                name='lastName'

                            />
                        </Form.Group>

                        <Form.Group widths='equal'>
                            <Form.Field >
                                <Form.Dropdown required
                                    label='Class'
                                    placeholder='Class'
                                    fluid
                                    search
                                    selection
                                    options={this.state.classDropdown}
                                    value={this.state.className}
                                    name='className'
                                    onChange={this.handleChangedValue}
                                />
                            </Form.Field>

                            <Form.Field required
                                label='Parent Name'
                                placeholder='Parent Name'
                                control='input'
                                type="text"
                                value={this.state.parentName}
                                onChange={(e) => { this.onChange(e) }}
                                name='parentName'

                            />
                        </Form.Group>

                        <Form.Group widths='equal'>

                            <Form.Field required
                                label='Email'
                                placeholder='Email'
                                control='input'
                                type="email"
                                value={this.state.email}
                                onChange={(e) => { this.onChange(e) }}
                                name='email'

                            />

                            <Form.Field required
                                label='City'
                                placeholder='City'
                                control='input'
                                type="text"
                                value={this.state.city}
                                onChange={(e) => { this.onChange(e) }}
                                name='city'

                            />
                        </Form.Group>

                        <Form.Group widths='equal'>

                            <Form.Field required
                                label='Pin Code'
                                placeholder='Pin Code'
                                control='input'
                                type="text"
                                value={this.state.pin}
                                onChange={(e) => { this.onChange(e) }}
                                name='pin'
                                maxLength={6}
                                onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                    }
                                }}

                            />

                            <Form.Field required
                                //label='Owner'
                                placeholder='Owner'
                                control='input'
                                type="text"
                                value={this.state.owner}
                                onChange={(e) => { this.onChange(e) }}
                                name='owner'
                                disabled
                                style={{ visibility: 'hidden' }}
                            />
                        </Form.Group>



                        {!this.state.iframeVisible ? <iframe scrolling="no" width="100%" height="300px" src={`${importIframeURL}phoneNumber=${this.state.phone}&orgcode=${this.props.orgCode}&userName=${this.state.firstName}`}></iframe> : ''}

                        <Button size='large' primary disabled={this.state.buttonDisabled} className="custom-container-btn" loading={this.state.btnLoader} >Submit</Button></> : ''}
                </Form>
                <CustomMessage open={this.state.open} message={this.state.message} close={this.setClose} />

            </Container>
        );
    }
}

export default CustomForm;